export default __webpack_public_path__ + "static/media/Group5.a348f1e4.svg";